import { createTheme } from '@mui/material/styles';

// Яркая и акцентированная палитра
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#6366F1', // Яркий индиго - насыщенный и современный
      light: '#818CF8',
      dark: '#4F46E5',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#EC4899', // Яркий розовый - энергичный акцент
      light: '#F472B6',
      dark: '#DB2777',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F5F7FA', // Чистый белый фон для максимального контраста
      paper: '#FFFFFF',
    },
    text: {
      primary: '#111827', // Глубокий черный для максимальной читаемости
      secondary: '#374151', // Темно-серый для второстепенного текста
    },
    divider: '#D1D5DB', // Четкая серая линия-разделитель
    error: {
      main: '#EF4444', // Яркий красный
      light: '#F87171',
      dark: '#DC2626',
    },
    warning: {
      main: '#F59E0B', // Яркий оранжевый
      light: '#FBBF24',
      dark: '#D97706',
    },
    info: {
      main: '#3B82F6', // Яркий синий
      light: '#60A5FA',
      dark: '#2563EB',
    },
    success: {
      main: '#10B981', // Яркий зеленый
      light: '#34D399',
      dark: '#059669',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      color: '#111827',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
      lineHeight: 1.3,
      color: '#111827',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: 1.3,
      color: '#111827',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.4,
      color: '#111827',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: 1.4,
      color: '#111827',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.5,
      color: '#111827',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      fontWeight: 500,
      color: '#111827',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
      fontWeight: 500,
      color: '#374151',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.5px',
      padding: '6px',
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    'none',
    '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24)',
    '0px 2px 4px rgba(0, 0, 0, 0.12), 0px 2px 3px rgba(0, 0, 0, 0.24)',
    '0px 3px 6px rgba(0, 0, 0, 0.15), 0px 3px 4px rgba(0, 0, 0, 0.25)',
    '0px 4px 8px rgba(0, 0, 0, 0.15), 0px 4px 5px rgba(0, 0, 0, 0.25)',
    '0px 5px 10px rgba(0, 0, 0, 0.18), 0px 5px 6px rgba(0, 0, 0, 0.28)',
    '0px 6px 12px rgba(0, 0, 0, 0.18), 0px 6px 7px rgba(0, 0, 0, 0.28)',
    '0px 7px 14px rgba(0, 0, 0, 0.2), 0px 7px 8px rgba(0, 0, 0, 0.3)',
    '0px 8px 16px rgba(0, 0, 0, 0.2), 0px 8px 9px rgba(0, 0, 0, 0.3)',
    '0px 9px 18px rgba(0, 0, 0, 0.22), 0px 9px 10px rgba(0, 0, 0, 0.32)',
    '0px 10px 20px rgba(0, 0, 0, 0.22), 0px 10px 11px rgba(0, 0, 0, 0.32)',
    '0px 11px 22px rgba(0, 0, 0, 0.24), 0px 11px 12px rgba(0, 0, 0, 0.34)',
    '0px 12px 24px rgba(0, 0, 0, 0.24), 0px 12px 13px rgba(0, 0, 0, 0.34)',
    '0px 13px 26px rgba(0, 0, 0, 0.26), 0px 13px 14px rgba(0, 0, 0, 0.36)',
    '0px 14px 28px rgba(0, 0, 0, 0.26), 0px 14px 15px rgba(0, 0, 0, 0.36)',
    '0px 15px 30px rgba(0, 0, 0, 0.28), 0px 15px 16px rgba(0, 0, 0, 0.38)',
    '0px 16px 32px rgba(0, 0, 0, 0.28), 0px 16px 17px rgba(0, 0, 0, 0.38)',
    '0px 17px 34px rgba(0, 0, 0, 0.3), 0px 17px 18px rgba(0, 0, 0, 0.4)',
    '0px 18px 36px rgba(0, 0, 0, 0.3), 0px 18px 19px rgba(0, 0, 0, 0.4)',
    '0px 19px 38px rgba(0, 0, 0, 0.32), 0px 19px 20px rgba(0, 0, 0, 0.42)',
    '0px 20px 40px rgba(0, 0, 0, 0.32), 0px 20px 21px rgba(0, 0, 0, 0.42)',
    '0px 21px 42px rgba(0, 0, 0, 0.34), 0px 21px 22px rgba(0, 0, 0, 0.44)',
    '0px 22px 44px rgba(0, 0, 0, 0.34), 0px 22px 23px rgba(0, 0, 0, 0.44)',
    '0px 23px 46px rgba(0, 0, 0, 0.36), 0px 23px 24px rgba(0, 0, 0, 0.46)',
    '0px 24px 48px rgba(0, 0, 0, 0.36), 0px 24px 25px rgba(0, 0, 0, 0.46)',
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '4px 8px',
          boxShadow: '0px 2px 8px rgba(99, 102, 241, 0.2)',
          fontWeight: 600,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0px 4px 16px rgba(99, 102, 241, 0.35)',
          },
        },
        contained: {
          boxShadow: '0px 3px 10px rgba(99, 102, 241, 0.3)',
          '&:hover': {
            boxShadow: '0px 6px 20px rgba(99, 102, 241, 0.4)',
          },
        },
        outlined: {
          borderWidth: '2px',
          boxShadow: 'none',
          '&:hover': {
            borderWidth: '2px',
            boxShadow: '0px 2px 8px rgba(99, 102, 241, 0.2)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12), 0px 2px 8px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(209, 213, 219, 0.8)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15), 0px 2px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(209, 213, 219, 0.5)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: '#FFFFFF',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6366F1',
              borderWidth: '2px',
            },
            '&.Mui-focused': {
              backgroundColor: '#FFFFFF',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#6366F1',
                borderWidth: '2px',
              },
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15), 0px 2px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;
